export function getAll() {
  return [
    {
      value: 0,
      name: "Disabled",
      text: "關閉",
    },
    {
      value: 1,
      name: "MenuOnly",
      text: "僅看菜單",
    },
    {
      value: 2,
      name: "Enabled",
      text: "開啟",
    },
  ];
}
